function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,30a25.9,25.9,0,0,1-8.91,19.59L40,42,32,30l13-1Z",
    style: {
      fill: "#2bb6e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,30H32l8-12,8.09-7.59A25.9,25.9,0,0,1,57,30Z",
    style: {
      fill: "#fccb55"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.09,50.8a2.011,2.011,0,0,1-.38,2.91,29,29,0,1,1,0-47.42,2.011,2.011,0,0,1,.38,2.91l-1,1.21L32,30,48.09,49.59Z",
    style: {
      fill: "#9e82ec"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.b3588aed883569f3ce16fa1cc911b9da.svg";
export { ForwardRef as ReactComponent };